import { DebugItem } from '@/models/ui/DebugItem'
import { FilterDebug } from '@/models/filter/FilterDebug'

export interface IDebugState {  
  debugEnable: boolean
  debugStatus: string
  items: Array<DebugItem>    
  debugFilter: FilterDebug
}

//Initial State
const state: IDebugState = {
  debugEnable: false,
  debugStatus: '',
  items: [],
  debugFilter : new FilterDebug()
}
export default state